import classNames from 'classnames';
import { ReactComponent as RequestStatusIcon } from '@Icons/additional/desktop-status.svg';
import { ReactComponent as RequestNoIcon } from '@Icons/additional/desktop-request.svg';
import { ReactComponent as RequestDatesIcon } from '@Icons/additional/deskop-calendar.svg';
import { Col, Flex, Row, Typography } from 'antd';

import styles from './requisition-info.module.css';

interface RequisitionInfoProps {
  requisitionNo: number | string;
  requisitionDate: string;
  requisitionStatus: string;
}

const { Text } = Typography;

const RequisitionInformation: React.FC<RequisitionInfoProps> = ({
  requisitionNo = 0,
  requisitionDate = '',
  requisitionStatus,
}) => {
  return (
    <Flex className={styles.headerForm}>
      <Row wrap={false} style={{ width: '100%' }}>
        <Col
          className={classNames(
            styles.headerContainer,
            'trojan-glassphormism-box trojan-glassphormism-box-shadow'
          )}
        >
          <Flex justify="space-between" align="center">
            <Flex vertical gap={5}>
              <span className={styles.headerText}>Request No.</span>
              <Text
                title={String(requisitionNo)}
                className={styles.headerDataText}
                strong
              >
                {requisitionNo}
              </Text>
            </Flex>
            <Flex align="center">
              <div>
                <RequestNoIcon />
              </div>
            </Flex>
          </Flex>
        </Col>
        <Col
          className={classNames(
            styles.headerContainer,
            'trojan-glassphormism-box trojan-glassphormism-box-shadow'
          )}
        >
          <Flex justify="space-between" align="center">
            <Flex vertical gap={5}>
              <span className={styles.headerText}>Request Date</span>
              <Text className={styles.headerDataText} strong>
                {requisitionDate}
              </Text>
            </Flex>

            <Flex gap={10} align="center">
              <div>
                <RequestDatesIcon />
              </div>
            </Flex>
          </Flex>
        </Col>
        <Col
          className={classNames(
            styles.headerContainer,
            'trojan-glassphormism-box trojan-glassphormism-box-shadow'
          )}
        >
          <Flex justify="space-between" align="center">
            <Flex vertical gap={5}>
              <span className={styles.headerText}>Request Status</span>
              <Text className={styles.headerDataText} strong>
                {requisitionStatus}
              </Text>
            </Flex>

            <Flex gap={10} align="center">
              <div>
                <RequestStatusIcon />
              </div>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </Flex>
  );
};

export default RequisitionInformation;
